import { useAppState } from '@/store/app'
import { usePosts } from '@/store/posts'
import { useSiteConfig } from '@/store/siteConfig'
import { fetchPosts, fetchTags, fetchCategories } from '@/services/api'
import { processPostsData, processTagsData, processCategoriesData, buildCategoryNameMap } from '@/services/dataProcessor'
import type { PostItem, TagItem, CategoryItem } from '@/types'

export function useAppInit() {
  const { setLoading, updateLastUpdateTime } = useAppState()
  const { setPosts, setTags, setCategories, clearAll } = usePosts()
  const { siteConfig } = useSiteConfig()

  async function initializeApp() {
    if (!siteConfig.url) {
      return
    }

    setLoading(true)
    const [postData, tagData, categoryData] = await Promise.all([
      fetchPosts(siteConfig.url),
      fetchTags(siteConfig.url),
      fetchCategories(siteConfig.url)
    ])

    const nameMap = buildCategoryNameMap(categoryData)

    if (postData) {
      const processed: PostItem[] = processPostsData(postData, nameMap)
      setPosts(processed)
      updateLastUpdateTime()
    }
    if (tagData) {
      const processedTags: TagItem[] = processTagsData(tagData)
      setTags(processedTags)
    }
    if (categoryData) {
      const processedCategories: CategoryItem[] = processCategoriesData(categoryData)
      setCategories(processedCategories)
    }
    setLoading(false)
  }

  function handleSiteChanged() {
    clearAll()
    initializeApp()
  }

  return {
    initializeApp,
    handleSiteChanged
  }
}
